import React from 'react';
import { Badge, cn } from '@crisellevaldez/speculo-ui';
import { Mail, PhoneOutgoing } from 'lucide-react';
import { MessageOutgoing } from '../../common/icons/DirectionIcons';

export type BadgeChannel = 'call' | 'sms' | 'email';

// Icons and colors match the outbound rows in Recent Activities and the
// contact's activity list (call/ealert classes, SMS outbound rose): a flow's
// activity is what it sent. Tailwind values so they replace Badge's default
// bg-primary through its class merge.
const CHANNEL_STYLE: Record<BadgeChannel, { icon: React.ReactNode; className: string }> = {
  call: {
    icon: <PhoneOutgoing className="w-3.5 h-3.5" />,
    className:
      'bg-[#d7ebe3] text-[#2a7a5a] border-[#2a7a5a]/30 dark:bg-[rgba(42,122,90,0.2)] dark:text-[#5cb895] dark:border-[#5cb895]/30',
  },
  sms: {
    icon: <MessageOutgoing className="w-3.5 h-3.5" />,
    className:
      'bg-rose-100 text-rose-600 border-rose-300 dark:bg-rose-500/15 dark:text-rose-400 dark:border-rose-500/40',
  },
  email: {
    icon: <Mail className="w-3.5 h-3.5" />,
    className:
      'bg-[#ede9fe] text-[#7c3aed] border-violet-300 dark:bg-[rgba(124,58,237,0.2)] dark:text-[#c4b5fd] dark:border-violet-500/40',
  },
};

/** A pill in the channel's color with its icon, e.g. the Activity Type column. */
export const ChannelBadge: React.FC<{
  channel: BadgeChannel;
  children: React.ReactNode;
  className?: string;
}> = ({ channel, children, className }) => (
  <Badge
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full border',
      CHANNEL_STYLE[channel].className,
      className
    )}
  >
    {CHANNEL_STYLE[channel].icon}
    {children}
  </Badge>
);
